import get from 'lodash.get';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouterV6 } from '../../../helpers/withRouterV6.jsx';
import { bindActionCreators } from 'redux';
import { I18n } from 'react-redux-i18n';
import clear from '../../../components/clear';
import BasePageView from '../../../components/common/basePageView';
import { Record } from '../../../modules/bin/utility';
import { getTabFromAccountTypes } from '../constants';
import AccountDetailHeaderContainer from './header';
import { prefetchAccountRetention } from '../../dataRetention/retentionApi';
import * as accountActions from './store/accountDetailActions';
import AccountDetailDonationsContainer from './table';
import { withPageTitle } from '../../../hocs';
import { capitalizeCamelCase } from '../../../helpers/stringUtils.js';

class AccountDetailPage extends Component {
  componentDidUpdate() {
    if (Record.isSuccess(this.props.impersonatedFundraiserRecord)) {
      const code = get(this.props.impersonatedFundraiserRecord, 'data');
      const impersonatedFundraiserUrlFull = get(
        this.props,
        'impersonatedFundraiserUrlFull'
      );

      window.open(
        `${impersonatedFundraiserUrlFull}/impersonate?code=${code}`,
        '_blank'
      );

      this.props.accountActions.clearRecordMessages(
        'impersonatedFundraiserRecord'
      );
    }
  }

  componentDidMount() {
    const accountId = this.props.match.params.id;
    this.props.accountActions.clearStore();
    this.props.accountActions.getRecord(accountId);
    if (this.props.isSystemAdmin) {
      prefetchAccountRetention(Number(accountId));
    }
  }

  getAccountsTabUrl() {
    if (this.props.record.data.data) {
      const account = this.props.record.data.data;
      return getTabFromAccountTypes(account);
    }
  }

  render() {
    return (
      <BasePageView
        isLoading={this.props.isLoading}
        isLoadingError={this.props.isLoadingError}
        backLink={`/accounts/${this.getAccountsTabUrl()}`}
        backLinkTitle="Back to accounts"
      >
        <div className="account-detail">
          <AccountDetailHeaderContainer />
          <div style={{ marginBottom: '2rem' }} />
          <AccountDetailDonationsContainer />
        </div>
      </BasePageView>
    );
  }
}

const mapState = ({ accountDetail, account, session }) => {
  return {
    isSystemAdmin: get(session, 'isSystemAdmin'),
    isLoading:
      Record.isRecordLoading(accountDetail.detailRecord) ||
      Record.isRecordLoading(accountDetail.impersonatedFundraiserRecord),
    isLoadingError: Record.isRecordLoadingError(accountDetail.detailRecord),
    record: accountDetail.detailRecord,
    impersonatedFundraiserRecord: accountDetail.impersonatedFundraiserRecord,
    impersonatedFundraiserUrlFull:
      accountDetail.impersonateFundraiser.fundraiserUrlFull
  };
};

const mapDispatch = (dispatch) => {
  return {
    accountActions: bindActionCreators(accountActions, dispatch)
  };
};

const titleResolver = (props) => {
  const email = get(props, 'record.data.data.email', '');
  const tab = get(props, 'match.params.tab', '');
  const capitalisedTab = capitalizeCamelCase(tab);
  return I18n.t('page-titles.accounts.detail', { email, tab: capitalisedTab });
};

const AccountDetailPageWithTitle = withPageTitle(titleResolver)(AccountDetailPage);

const AccountDetailPageContainer = withRouterV6(
  clear(connect(mapState, mapDispatch)(AccountDetailPageWithTitle))
);
export default AccountDetailPageContainer;
